import { useCallback, useEffect, useState } from 'react';
import { initializePaddle, Paddle } from '@paddle/paddle-js';
import useBillingType from '../account/UseBillingType';
import { REACT_APP_PROD_PADDLE, REACT_APP_TEST_PADDLE } from '../../utils/config';

const usePaddle = () => {
  const isProdBilling = useBillingType();
  const [paddle, setPaddle] = useState<Paddle>();

  const initPaddle = useCallback(async () => {
    const environment = isProdBilling ? 'production' : 'sandbox';
    const token = isProdBilling ? REACT_APP_PROD_PADDLE : REACT_APP_TEST_PADDLE;

    initializePaddle({ environment, token: token || '' }).then((paddleInstance: Paddle | undefined) => {
      if (paddleInstance) {
        setPaddle(paddleInstance);
      }
    });
  }, []);

  useEffect(() => {
    initPaddle();
  }, [initPaddle]);

  return { paddle, initPaddle };
};

export default usePaddle;
